import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../Components/Spinner";
import { useLanguage } from "../Translations/LenguageContext";
import ErrorMessage from "../Components/ErrorMessage";
import GoogleLogin from "./GoogleLogin";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

function Login() {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [showPassword, setShowPassword] = useState(false);
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [rememberChecked, setRememberChecked] = useState(true)


    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            startLogin();
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    function startLogin() {
        setErr({ message: "", display: false })
        const email_reg = document.getElementById("email_reg");
        const password_reg = document.getElementById("password_reg");

        let error = false;
        let error_email = false;
        let error_password = false;

        if (email_reg.value === "") {
            error = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else if (!validateEmail(email_reg.value)) {
            error = true;
            error_email = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else {
            email_reg.style.border = "";
        }

        if (password_reg.value === "") {
            error = true;
            password_reg.style.border = "1px solid var(--danger)";
        } else {
            password_reg.style.border = "";
        }

        if (error) {
            if (error_email) {
                setErr({ message: t.register_form.email_format, display: true });
            } else if (error_password) {
                setErr({ message: t.register_form.password_err, display: true });
            } else {
                setErr({ message: t.register_form.red_fields, display: true });
            }
        } else {
            loginUser(email_reg.value, password_reg.value);
            setErr({ message: "", display: false });
        }
    }

    function loginUser(email, password) {
        setLoading(true);
        const dataToSend = {
            email: email,
            password: password,
        };
        fetch(`${GEN_BACKEND_LINK}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if (data.message === "OK") {
                    const account_id = data.account_id;
                    if (rememberChecked) {
                        document.cookie = `account_id=${account_id}; path=/; max-age=` + (7 * 24 * 60 * 60);
                    }
                    localStorage.setItem("account_id", account_id);
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                    if (isMobile) {
                        navigate("/mobile_device");
                    } else {
                        if (data.email_verified) {
                            if (data.onboarding.completed) {
                                navigate("/console/organizations");
                            } else {
                                navigate(`/onboarding/welcome`);
                            }
                        } else {
                            navigate(`/verify-email?email=${email}`);
                        }
                    }
                } else if (data.message === "Invalid_email_or_password") {
                    setErr({ message: t.register_form.invalid_email_pass, display: true });
                } else if (data.message === "email_not_valid") {
                    setErr({ message: t.register_form.email_format, display: true });
                } else if (data.message === "account_not_exists") {
                    setErr({ message: "Account does not exist. Please register first.", display: true });
                } else if (data.error) {
                    setErr({ message: t.register_form.errors_back, display: true });
                }
            })
            .catch(error => {
                setLoading(false);
                console.error(error);
                setErr({ message: t.register_form.problem_back, display: true });
            });
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };



    return (
        <div className="register_container_reg">
            <div className="reg_cont ">
                <p className="title_form fade-in" >{t.register_form.welcome_back}</p>
                <input type="text" id="email_reg" placeholder="Email" className="register_form_first fade-in" />
                <div className="password_eye fade-in">
                    <input type={showPassword ? "text" : "password"} id="password_reg" placeholder="Password" className="register_form_first" />
                    <button className="show_passowrd" onClick={togglePasswordVisibility}>
                        <i className={`fa-regular fa-eye${showPassword ? "" : "-slash"}`}></i>
                    </button>
                </div>
                <ErrorMessage err={err} />
                <button onClick={startLogin} className="start_btn fade-in">
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (
                        <>
                            {t.register_form.button_login}
                        </>
                    )
                    }
                </button>
                <div className="reg_auth_ext_cont fade-in">
                    <GoogleLogin type_enter={"Login"} />
                </div>
                <p className="already_present fade-in">{t.register_form.dont_have_account} <span onClick={() => navigate("/register")}> {t.register_form.go_register}</span></p>
            </div>
        </div>
    );
}

export default Login;
